// Port of src/app/services/youtube/youtube-base-api.service.ts (Angular base
// class → shared module functions).

import { http } from '../http';
import { environment } from '../../config/environment';
import * as youtubeTokens from './youtube-tokens';

declare const google: any;

const youtubeTokenUrl = 'https://oauth2.googleapis.com/token';

export function initGoogleAccount(): void {
  window.onload = () => {
    google.accounts.id.initialize({
      client_id: environment.youtubeClientId,
      callback: handleCredentialResponse
    });
  };
}

// Refresh the YouTube access token
export async function refreshAccessToken(): Promise<string> {
  const body = new URLSearchParams({
    client_id: environment.youtubeClientId,
    client_secret: environment.youtubeClientSecret,
    refresh_token: youtubeTokens.getRefreshToken(),
    grant_type: 'refresh_token'
  });

  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };

  try {
    const res = await http.post<any>(youtubeTokenUrl, body.toString(), { headers });
    const data = res.data;

    if (data.access_token) {
      youtubeTokens.setAccessToken(data.access_token);
      youtubeTokens.setRefreshToken(data.refresh_token);
    }

    if (data && data.access_token) {
      // ... (handle successful response)
      return data.access_token;
    } else {
      throw new Error('Failed to refresh token');
    }
  } catch (error) {
    console.error('Error refreshing YouTube access token', error);
    throw new Error('Error refreshing YouTube access token');
  }
}

export async function getUserProfile(): Promise<any> {
  const accessToken = youtubeTokens.getAccessToken();
  if (!accessToken) {
    throw new Error('No access token available');
  }

  const res = await http.get<any>(
    'https://people.googleapis.com/v1/people/me?personFields=names,emailAddresses',
    { headers: { 'Authorization': `Bearer ${accessToken}` } }
  );
  return res.data;
}

export async function exchangeCodeForToken(code: string): Promise<any> {
  const body = new URLSearchParams({
    client_id: environment.youtubeClientId,
    client_secret: environment.youtubeClientSecret,
    code: code,
    grant_type: 'authorization_code',
    redirect_uri: environment.youtubeRedirectUri
  });

  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };

  const res = await http.post<any>('https://oauth2.googleapis.com/token', body.toString(), { headers });
  return res.data;
}

// Handle API errors
export function handleError(error: any): any {
  console.error(error); // Log the error to the console (or send to server logs)
  return { error: 'An error occurred while processing your request.' } as any;
}

function handleCredentialResponse(_response: any): void {
  console.log('google authenticated');
  // Here, you'll handle the response token, typically sending it to your backend for verification
  // console.log('Encoded JWT ID token: ' + response.credential);
}
